// extracted by mini-css-extract-plugin
export default {"wrapper":"agree-page_wrapper__KMVOr","privacy":"agree-page_privacy__IMn6X","title":"agree-page_title__61pGi","list":"agree-page_list__wYnnN"};